import { Icon } from "semantic-ui-react";

import type { Assign, OpenAPI } from "simplydo/interfaces";

import { TooltipButton } from "components/lib/UI";

type DownloadCoverImageActionProps = {
  idea: Assign<
    OpenAPI.Schemas["Idea"],
    OpenAPI.Schemas["AssignIdeaChallenges"],
    OpenAPI.Schemas["AssignIdeaUrls"]
  >;
};

const DownloadCoverImageAction = ({ idea }: DownloadCoverImageActionProps) => {
  if (idea.ownerChallenge?.preventIdeaCoverImages || !idea.coverImage) {
    return null;
  }

  return (
    <TooltipButton
      as="a"
      href={idea.coverImageUrl}
      target="_blank"
      rel="noopener noreferrer"
      download={idea.coverImage}
      icon
      tooltip="Download cover image"
    >
      <Icon name="download" />
    </TooltipButton>
  );
};

export default DownloadCoverImageAction;
